import React, { useEffect, useState } from "react";
import api from "../../api/axiosAuth";

export default function Certificados() {
  const [tipos, setTipos] = useState([]);
  const [estudiantes, setEstudiantes] = useState([]);
  const [certificados, setCertificados] = useState([]);

  const [tipoForm, setTipoForm] = useState({
    nombre: "",
    descripcion: "",
    plantilla_html: "",
    incluye_notas: false,
  });

  const [generarForm, setGenerarForm] = useState({
    estudiante_id: "",
    tipo_certificado_id: "",
    grado: "",
    grupo: "",
    anio: "",
    periodo: "",
  });

  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);

  /* =====================================================
     🔹 CARGA INICIAL
  ===================================================== */
  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const [tiposRes, estRes, certRes] = await Promise.all([
        api.get("/certificados/tipos"),
        api.get("/matriculas/estudiantes"), // ✅ CORREGIDO
        api.get("/certificados"),
      ]);

      setTipos(tiposRes.data);
      setEstudiantes(estRes.data);
      setCertificados(certRes.data);

    } catch (error) {
      console.error("❌ Error cargando datos", error);
    }
  };

  /* =====================================================
     🔹 HANDLE FORM CREAR TIPO
  ===================================================== */
  const handleTipoChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTipoForm({
      ...tipoForm,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const guardarTipo = async () => {
    try {
      await api.post("/certificados/tipos", tipoForm);
      alert("✅ Tipo creado");

      setTipoForm({
        nombre: "",
        descripcion: "",
        plantilla_html: "",
        incluye_notas: false,
      });

      cargarDatos();

    } catch (error) {
      console.error("❌ Error creando tipo", error);
    }
  };

  /* =====================================================
     🔹 SELECCIONAR ESTUDIANTE (AUTO GRADO/GRUPO)
  ===================================================== */
  const handleEstudiante = (e) => {
    const id = parseInt(e.target.value);

    const est = estudiantes.find((x) => x.id === id);

    if (!est) return;

    setGenerarForm({
      ...generarForm,
      estudiante_id: est.id,
      grado: est.grado || "",
      grupo: est.grupo || "",
      anio: est.anio_lectivo_id || "",
    });
  };

  /* =====================================================
     🔹 HANDLE FORM GENERAR
  ===================================================== */
  const handleGenerarChange = (e) => {
    setGenerarForm({
      ...generarForm,
      [e.target.name]: e.target.value,
    });
  };

  const generarCertificado = async () => {
    try {
      setLoading(true);

      const res = await api.post("/certificados/generar", generarForm);

      // 🔥 preview HTML
      setPreview(res.data.html);

      // 🔥 descarga PDF automática
      if (res.request.responseType === "blob") {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "certificado.pdf");
        document.body.appendChild(link);
        link.click();
      }

      cargarDatos();

    } catch (error) {
      console.error("❌ Error generando certificado", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>🧾 Módulo de Certificados</h2>

      {/* =====================================================
         🔹 CREAR TIPO
      ===================================================== */}
      <div className="card" style={{ marginBottom: 20, padding: 10 }}>
        <h3>Crear Tipo de Certificado</h3>

        <input
          name="nombre"
          placeholder="Nombre"
          value={tipoForm.nombre}
          onChange={handleTipoChange}
        />

        <input
          name="descripcion"
          placeholder="Descripción"
          value={tipoForm.descripcion}
          onChange={handleTipoChange}
        />

        <textarea
          name="plantilla_html"
          placeholder="Usa {{nombre}}, {{grado}}, {{grupo}}, {{periodo}}, {{tabla_notas}}"
          value={tipoForm.plantilla_html}
          rows={6}
          onChange={handleTipoChange}
        />

        <label>
          <input
            type="checkbox"
            name="incluye_notas"
            checked={tipoForm.incluye_notas}
            onChange={handleTipoChange}
          />
          Incluye notas
        </label>

        <br />
        <button onClick={guardarTipo}>Guardar</button>
      </div>

      {/* =====================================================
         🔹 GENERAR CERTIFICADO
      ===================================================== */}
      <div className="card" style={{ marginBottom: 20, padding: 10 }}>
        <h3>Generar Certificado</h3>

        <select
          name="tipo_certificado_id"
          value={generarForm.tipo_certificado_id}
          onChange={handleGenerarChange}
        >
          <option value="">Tipo</option>
          {tipos.map((t) => (
            <option key={t.id} value={t.id}>
              {t.nombre}
            </option>
          ))}
        </select>

        <select onChange={handleEstudiante}>
          <option value="">Estudiante</option>
          {estudiantes.map((e) => (
            <option key={e.id} value={e.id}>
              {e.nombre} - {e.grado}-{e.grupo}
            </option>
          ))}
        </select>

        <input
          name="grado"
          placeholder="Grado"
          value={generarForm.grado}
          onChange={handleGenerarChange}
        />

        <input
          name="grupo"
          placeholder="Grupo"
          value={generarForm.grupo}
          onChange={handleGenerarChange}
        />

        <input
          name="anio"
          placeholder="Año"
          value={generarForm.anio}
          onChange={handleGenerarChange}
        />

        <input
          name="periodo"
          placeholder="Periodo"
          value={generarForm.periodo}
          onChange={handleGenerarChange}
        />

        <button onClick={generarCertificado} disabled={loading}>
          {loading ? "Generando..." : "Generar"}
        </button>
      </div>

      {/* =====================================================
         🔹 PREVIEW
      ===================================================== */}
      <div className="card" style={{ marginBottom: 20, padding: 10 }}>
        <h3>Vista previa</h3>

        {preview ? (
          <div
            dangerouslySetInnerHTML={{ __html: preview }}
            style={{
              border: "1px solid #ccc",
              padding: 20,
              background: "#fff",
            }}
          >
            <div style={{ marginTop: 40, textAlign: "right" }}>
              <p>_________________________</p>
              <p>Rector</p>
            </div>
          </div>
        ) : (
          <p>No hay certificado</p>
        )}
      </div>

      {/* =====================================================
         🔹 HISTORIAL
      ===================================================== */}
      <div className="card" style={{ padding: 10 }}>
        <h3>Historial</h3>

        {certificados.length === 0 && <p>No hay datos</p>}

        {certificados.map((c) => (
          <div key={c.id}>
            {c.estudiante} - {c.grado} - {c.anio} - {c.tipo}
          </div>
        ))}
      </div>
    </div>
  );
}
